import { render, staticRenderFns } from "./BarcodeScannerGun.vue?vue&type=template&id=b78fbf2a&scoped=true"
import script from "./BarcodeScannerGun.vue?vue&type=script&lang=js"
export * from "./BarcodeScannerGun.vue?vue&type=script&lang=js"
import style0 from "./BarcodeScannerGun.vue?vue&type=style&index=0&id=b78fbf2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78fbf2a",
  null
  
)

export default component.exports